export function makeFragmentId(text: string) {
  return text
    .trim()
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/\u00AD/g, '') // replace soft hyphen
    .replace(/\?/g, '');
}
